import Singleton from './Singleton'
import Storage from './Storage'
import {Cache, Resource} from './Cache'
import dayjs from 'dayjs'
import {message} from 'antd'
import axios from 'axios'
import {createDirectus, createItem, readItems, rest} from '@directus/sdk'
import {Languages} from './Languages'

export default class App extends Singleton {
  static config = {
    default_language: "cs-CZ"
  }

  static _languages = [
    {key: 'cs-CZ', name: 'Čeština'},
    {key: 'en-US', name: 'English'},
  ]

  static API_URL = (document.location.hostname === 'localhost') ? 'http://localhost/api/' : `https://${document.location.hostname}/api/`
  static STORE = {
    is_authorized: false,
    customer_id: null,
    is_test_user: null
  }
  touched_flag = false
  i18nDATA = {}

  constructor() {
    super()


    //this.message = message
    this.i18nDATA = {}


    // DIRECUTS API
    this._directus = createDirectus('https://trailsoficeandfire.dobiland.com').with(rest())

    axios.interceptors.response.use((response) => {

      return response.data

    }, (error) => {

      if(error.hasOwnProperty('response') && error.response.hasOwnProperty('error'))
        return Promise.reject(error.response.data)
      else if(error.hasOwnProperty('message'))
        return Promise.reject(error.message)
      else
        return Promise.reject('No internet connection')

    })


    //this._language = new Languages(this)

    window.$app = this
  }

  static $toast(content, type = 'success') {
    void message.open({type: type, content: content})
  }

  static $e(content) {
    this.$toast(content, 'error')
  }

  async $directus (route, options) {
    if(options.hasOwnProperty('data')) {
      return await this._directus.request(createItem(route, options.data))
    }

    else
      return await this._directus.request(readItems(route, options))
  }

  async $directusCreate (collection, item){
    return await this._directus.request(createItem(collection, item))
  }


  async $api(request) {
    return new Promise(async (resolve, reject) => {

      try {
        const {action = 'default', headers = null} = request

        delete request.headers

        const response = await axios({
          withCredentials: true,
          url: `${App.API_URL}?action=${action}`,
          method: 'POST',
          headers: headers,
          data: {
            ...request
          }
        })

        /*if(response && response.hasOwnProperty('errors')){

          response.errors.forEach((message) => {
            App.$e(message.title)
          })
          reject(response.error)

        }
        if(response && response.hasOwnProperty('error')) {

          App.$e(response.error.title)
          reject(response.error)

        }*/

        if(response && response.hasOwnProperty('error')) reject(response.error)
        else resolve(response)

      } catch (error) {

        reject(error)

      }
    })
  }

  async $resource(name, request) {
    const resources = Cache.resources
    const customer_id = App.STORE.customer_id
    const resource = (resources.hasOwnProperty(name) ? new Resource(resources[name], customer_id) : false)

    if(resource instanceof Resource && resource.isValid) return Promise.resolve(resource.data)

    const response = await this.$api(request)

    if(response && typeof response === 'object') {

      const data = {}
      const statestamp = dayjs().unix()

      data[name] = {
        ...response,
        statestamp,
        customer_id
      }

      Cache.extend(data)

    }

    return Promise.resolve(response)
  }

  /**
   * Get translations
   */
  async $t(...keys) {
    return this._findByKeys(keys, this.i18nDATA)
  }

  $tc(...args) {

    const count = args.pop()
    const plurals = this._findByKeys(args, this.i18nDATA).split('|').map(item => item.trim())

    if(count === 1)
      return plurals[0]
    if(plurals.length === 3 && (4 < count || count === 0))
      return plurals[2]

    return plurals[1]
  }

  $language(active = null) {
    if(active)
      this.$storage.local.set('active_language', active)

    return this.$storage.local.get('active_language')
  }

  _findByKeys(keys, data) {

    // Result key found
    if(keys.length === 0)
      return data

    if(data[keys[0]] !== undefined) {
      let original = keys.shift()
      return this._findByKeys(keys, data[original])
    } else {
      console.error(`JS lang key ${keys} not exist`)
      return `[JS lang key ${keys} not exist]`
    }
  }

  $e(content) {
    App.$e(content)
  }

  /**
   *
   * @returns {Promise<{is_test_user: null, is_authorized: boolean, customer_id: null}>}
   */
  async $auth() {
    if(!this.touched_flag) {
      let data = await this.$api({action: 'touch'})
      App.STORE = data
      this.touched_flag = true
    }

    return App.STORE
  }

  get $storage () {
    return Storage.instance
  }
}

export const $app = App.instance
export const $toast = App.$toast